function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_27917_30202)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.6 8.36C29.13 5.6 26.73 3.5 23.83 3.5C21.32 3.5 19.18 5.08 18.35 7.29C18.12 7.25 17.88 7.22 17.64 7.22C15.6 7.22 13.94 8.87 13.94 10.91C13.94 11.14 13.97 11.37 14.01 11.59C11.8 11.89 10.09 13.78 10.09 16.06C10.09 18.56 12.12 20.58 14.62 20.58H28.66C32.06 20.58 34.82 17.83 34.82 14.43C34.82 11.35 32.55 8.81 29.59 8.36H29.6Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.35 7.28998C20.09 7.71998 21.12 9.14998 21.12 10.57",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.67 41.5C14.5257 41.5 16.03 39.9957 16.03 38.14C16.03 36.2844 14.5257 34.78 12.67 34.78C10.8143 34.78 9.31 36.2844 9.31 38.14C9.31 39.9957 10.8143 41.5 12.67 41.5Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.01 41.5C35.8657 41.5 37.37 39.9957 37.37 38.14C37.37 36.2844 35.8657 34.78 34.01 34.78C32.1543 34.78 30.65 36.2844 30.65 38.14C30.65 39.9957 32.1543 41.5 34.01 41.5Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.04 38.14H30.64",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.75 25.51H17.93C16.55 25.51 15.18 25.85 13.96 26.51L8.86999 29.24L6.53999 29.53C5.79999 29.62 5.23999 30.25 5.23999 30.99V32.33C5.23999 32.7 5.14999 33.07 4.97999 33.4L4.74999 33.84C4.57999 34.17 4.48999 34.55 4.48999 34.92V35.93C4.48999 36.56 4.90999 37.12 5.51999 37.31L6.85999 37.71C7.81999 38 8.29999 38.15 9.29999 38.15",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.37 38.14H38.16L41.52 37.28C42.09 37.13 42.49 36.62 42.49 36.03V35.03C42.49 34.79 42.4 34.55 42.23 34.38L41.95 34.09C41.77 33.9 41.67 33.65 41.67 33.39V32.82C41.67 32.3 41.37 31.82 40.9 31.6C39.63 31 38.28 30.58 36.89 30.36L33.49 29.81L27.67 26.49C27.28 26.27 26.87 26.08 26.45 25.94",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.04 33.37C25.04 34.79 23.89 35.94 22.46 35.94C21.03 35.94 19.88 34.79 19.88 33.37C19.88 31.95 22.46 28.97 22.46 28.97C22.46 28.97 25.04 31.95 25.04 33.37V33.37Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.88 29.94C18.88 30.72 18.24 31.36 17.46 31.36C16.68 31.36 16.04 30.72 16.04 29.94C16.04 29.16 17.46 27.51 17.46 27.51C17.46 27.51 18.88 29.15 18.88 29.94V29.94Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.44 31.15C29.44 31.93 28.8 32.57 28.02 32.57C27.24 32.57 26.6 31.93 26.6 31.15C26.6 30.37 28.02 28.72 28.02 28.72C28.02 28.72 29.44 30.36 29.44 31.15V31.15Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.47 26.01C26.47 26.79 25.83 27.43 25.05 27.43C24.27 27.43 23.63 26.79 23.63 26.01C23.63 25.23 25.05 23.58 25.05 23.58C25.05 23.58 26.47 25.22 26.47 26.01V26.01Z",
  stroke: "#FF7A00",
  className: "color-error-stroke",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_27917_30202"
}, /*#__PURE__*/React.createElement("rect", {
  width: 39,
  height: 39,
  fill: "white",
  transform: "translate(4 3)"
})));
function SvgRainy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainy);
export default __webpack_public_path__ + "static/media/rainy.b3c8b442230c93a890a0868f59490d5d.svg";
export { ForwardRef as ReactComponent };